export default __webpack_public_path__ + "static/media/abi.d6c2c3b0.jpg";